import { CmsPromotionalCard } from '../../interface';
import { formatDate, formatText } from '../formatter';
import { Price } from '@vfde-brix/ws10/core';
import { ProductContainerProps } from '../../container/Product';

const getSubline = (
    props: ProductContainerProps,
    cmsProps: CmsPromotionalCard,
) => {
    const product = props.tvConnect ?? props.tvConnectBv;

    if (props.hasTvConnect) {
        return cmsProps.hasTvConnect;
    }

    if (!product) {
        return cmsProps.preAvailability;
    }

    const price = product.priceAddons.discountedPrice?.price.value ?? product.price.value;
    const priceString = Price.fromNumber(price).toString();

    let result = props.customer && props.tvConnectBv
        ? formatText(cmsProps.broadVisionAvailability, product.name, priceString)
        : formatText(cmsProps.postAvailability, product.name, priceString);

    if (props.marketability?.mnvEndDate && price > 0) {
        result += formatText(cmsProps.mnvEndDate, formatDate(props.marketability.mnvEndDate));
    }

    result += cmsProps.moreInfo;

    return result;
};

export default {
    getSubline,
};
